import BasePage from '../../components/base-page/base-page';
import Carousel from '../../components/carousel/carousel';
import breakpoints from '../../config/breakpoints';

import analytics, { events } from '../../../shared/analytics';

import './pricing-personal.scss';

export default class PricingPersonalPage extends BasePage {
  ui = {
    ctaSection: '.js-pricing-cta-section',
    familyBannerButton: '.js-family-banner-button',
    testimonialsCarousel: '.js-testimonials-carousel',
    pricingSwitcher: '.pricing-switcher',
    pricingCardMonthly: '[data-price-plans="monthly"]',
    pricingCardAnnual: '[data-price-plans="annual"]',
  };

  events = {
    'change @ui.pricingSwitcher': 'handleSwitcherToggle',
    'click @ui.familyBannerButton': 'handleFamilyBannerButtonClick',
  };

  onInit() {
    super.onInit();

    this.testimonialsCarousel = new Carousel({
      rootElement: this.ui.testimonialsCarousel,
      slidesPerPage: {
        [breakpoints.sm]: 2,
        [breakpoints.lg]: 3,
      },
    });

    this.testimonialsCarousel.init();

    if ('IntersectionObserver' in window) {
      this.ui.ctaSection.classList.add('pricing-personal__cta-section_shifted');
      const ctaSectionObserver = new IntersectionObserver(this.handleCtaSectionIntersection);
      ctaSectionObserver.observe(this.ui.ctaSection);
    }
  }

  handleCtaSectionIntersection = (entries) => {
    entries.forEach((entry) => {
      this.ui.ctaSection.classList.toggle('pricing-personal__cta-section_shifted', !entry.isIntersecting);
    });
  };

  handleSwitcherToggle = (e) => {
    if (e) {
      this.ui.pricingCardMonthly.classList.toggle('hidden', e.target.checked);
      this.ui.pricingCardAnnual.classList.toggle('hidden', !e.target.checked);
    }
  };

  handleFamilyBannerButtonClick = () => analytics.trackEvent(events.PRICING_FAMILY_LEARN_MORE);
}

PricingPersonalPage.initOnDomLoaded();
